module.exports = __webpack_public_path__ + "img/corriente_b.f25fbd91.svg";